import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { classnames } from 'Utils/classnames';
import { resetLoginFailure } from 'Store/actions';

class DropPanelDesktop extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
    resetLoginFailure: PropTypes.func.isRequired,
    className: PropTypes.string,
    width: PropTypes.number,
  };

  componentWillUnmount () {
    this.props.resetLoginFailure();
  }

  render () {
    const { onClose, children, className, width } = this.props;

    const componentClass = classnames({
      'drop-panel-desktop': true,
      [className]: className,
    });

    const componentStyle = width ? { width: `${width}px` } : null;

    return (
      <>
        <div
          className="drop-panel-desktop-overlay"
          onClick={ onClose }
        />
        <div className={ componentClass } style={ componentStyle }>
          { children }
        </div>
      </>
    );
  }
}

const mapDispatchToProps = {
  resetLoginFailure,
};

export default connect(null, mapDispatchToProps)(DropPanelDesktop);
